import { EmployeeNewLeavePageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { SkeletonModal } from 'modules/core/components/Modal'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewLeaveModal from 'modules/timeoff/components/NewLeaveModal'

import { useOnClose } from './useOnClose'

const NewLeavePage = () => {
  const { id } = useStrictParams<'id'>()
  const onClose = useOnClose(id)

  const { data, loading } = useQuery(EmployeeNewLeavePageDocument, {
    variables: { employeeId: Number(id) },
  })

  if (loading) {
    return <SkeletonModal />
  }

  const currentEmployee = data?.apiCore.currentsConnection.edges[0]?.node.employee

  if (!currentEmployee) {
    throw new Error('Current employee not found')
  }

  const customResourceFieldsData =
    compact(
      data?.documents.foldersConnection.edges[0]?.node.resourceFieldsConnection.edges.map(
        (edge) => edge.node
      )
    ) ?? []

  const sickFolderId = data?.documents.foldersConnection.edges[0]?.node.id

  if (!sickFolderId) {
    throw new Error('Sick folder ID not found')
  }

  const leaveEmployee = data?.employees.employeesConnection.edges[0]?.node

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return (
    <NewLeaveModal
      customResourceFieldsData={customResourceFieldsData}
      currentEmployee={currentEmployee}
      leaveEmployee={leaveEmployee}
      sickFolderId={sickFolderId}
      onClose={onClose}
      leaveCanManageLeaveDocuments={false}
      approvalGroupMemberships={[]}
    />
  )
}

export default NewLeavePage
